export default "__VITE_ASSET__eFfxpvVF__"